'use client';

import { cn } from '@zealot/ui/lib/utils';
import * as React from 'react';

import { ColorPickerContext } from './color-picker';

const CHECKERBOARD_STYLE: React.CSSProperties = {
  backgroundImage: 'repeating-conic-gradient(#d4d4d8 0% 25%, #ffffff 0% 50%)',
  backgroundSize: '8px 8px',
};

type ColorPickerSwatchProps = React.ComponentProps<'span'> & {
  color?: string;
};

const ColorPickerSwatch = ({ color, className, ...props }: ColorPickerSwatchProps) => {
  const context = React.useContext(ColorPickerContext);
  const swatchColor = color ?? (context?.isEmpty ? undefined : context?.color);

  return (
    <span
      data-slot="color-picker-swatch"
      className={cn(
        'relative inline-flex size-6 shrink-0 overflow-hidden rounded-md ring-1 ring-foreground/10',
        className,
      )}
      data-empty={swatchColor ? undefined : ''}
      style={CHECKERBOARD_STYLE}
      {...props}
    >
      {swatchColor && <span aria-hidden className="absolute inset-0" style={{ backgroundColor: swatchColor }} />}
    </span>
  );
};

export type { ColorPickerSwatchProps };
export { ColorPickerSwatch };
